<template>
  <div class="h5-activity-push-list">
    <div class="header-container">
      <div class="filter-row">
        <Select
          v-model="searchForm.activityConfigId"
          placeholder="请选择推送活动"
          clearable
          filterable
          remote
          :remote-method="searchActivities"
          :loading="activityLoading"
          class="filter-item"
          @on-change="handleActivityFilterChange"
        >
          <Option
            v-for="item in activityOptions"
            :key="item.id"
            :value="item.id"
            :label="item.activityName"
          >
            {{ item.activityName }}
          </Option>
        </Select>

        <Select
          v-model="searchForm.crowdId"
          placeholder="请选择人群包"
          clearable
          filterable
          :loading="crowdLoading"
          class="filter-item"
        >
          <Option
            v-for="item in currentCrowdOptions"
            :key="'crowd-' + item.id"
            :value="item.id"
            :label="item.name"
          >
            {{ item.name }}
          </Option>
        </Select>

        <Select
          v-model="searchForm.entryType"
          placeholder="请选择活动入口"
          clearable
          class="filter-item"
        >
          <Option
            v-for="item in activityEntryTypeOptions"
            :key="'entry-type-' + item.value"
            :value="item.value"
          >
            {{ item.label }}
          </Option>
        </Select>

        <Select
          v-model="searchForm.status"
          placeholder="请选择开启状态"
          clearable
          class="filter-item"
        >
          <Option :value="1">开启</Option>
          <Option :value="0">关闭</Option>
        </Select>

        <Input
          v-model="searchForm.ruleName"
          placeholder="请输入推送规则名称搜索"
          clearable
          class="filter-item"
        />

        <Button type="primary" @click="getData(1)">搜索</Button>
        <Button @click="handleReset">重置</Button>
        <Button type="primary" @click="handleOpenEditModal()" class="btn-add">
          新增
        </Button>
      </div>
    </div>

    <div class="table-container">
      <Table :data="tableData" row-key="id" :columns="columns" :loading="tableLoading">
        <template #ruleName="{ row }">
          <div>
            <div>{{ row.ruleName }}</div>
            <div class="id-text">id: {{ row.showId }}</div>
          </div>
        </template>
        <template #activityName="{ row }">
          <span>{{ row.activityName || '-' }}</span>
        </template>
        <template #crowdNames="{ row }">
          <span>{{
            Number(row.crowdLimit) === 0 ? '不限' : row.crowdNames || '-'
          }}</span>
        </template>
        <template #entryNames="{ row }">
          <span>{{ row.entryNames || '-' }}</span>
        </template>
        <template #dailyTriggerLimit="{ row }">
          <span>{{
            row.dailyTriggerLimit === -1 ||
            row.dailyTriggerLimit === null ||
            row.dailyTriggerLimit === undefined
              ? '不限'
              : row.dailyTriggerLimit
          }}</span>
        </template>
        <template #status="{ row }">
          <i-switch
            :value="Number(row.status)"
            :true-value="1"
            :false-value="0"
            :disabled="tableLoading || Boolean(statusChangingId)"
            :loading="statusChangingId === row.id"
            @on-change="(val) => handleStatusChange(row, val)"
          />
        </template>
        <template #action="{ row }">
          <div class="action-buttons">
            <a @click="handleView(row)">查看</a>
            <a @click="handleOpenEditModal(row)">编辑</a>
            <a @click="handleDelete(row)">删除</a>
          </div>
        </template>
        <template #footer>
          <Pages :page="page" :func="getData"></Pages>
        </template>
      </Table>
    </div>

    <H5ActivityEditModal
      v-model="editVisible"
      :data="editForm"
      :readonly="editReadonly"
      @on-success="getData"
    />
  </div>
</template>

<script>
import { debounce } from 'lodash'
import Pages from '@/components/pages'
import H5ActivityEditModal from './H5ActivityEditModal.vue'
import { getCrowdList } from '@/api/crowd'
import {
  changeActivityPushRuleStatus,
  getActivityConfigOptions,
  getActivityPushCrowds,
  getActivityPushRuleDetail,
  getActivityPushRuleList,
  removeActivityPushRule
} from '@/api/activityPush'
import {
  ACTIVITY_ENTRY_TYPE_OPTIONS
} from './activityPushOptions'

export default {
  name: 'H5ActivityPushList',
  components: {
    Pages,
    H5ActivityEditModal
  },
  data() {
    return {
      searchForm: {
        activityConfigId: '',
        crowdId: '',
        entryType: '',
        status: '',
        ruleName: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableLoading: false,
      statusChangingId: '',
      crowdLoading: false,
      activityLoading: false,
      editVisible: false,
      editReadonly: false,
      editForm: {},
      tableData: [],
      activityOptions: [],
      globalCrowdOptions: [],
      activityCrowdOptions: [],
      columns: [
        {
          title: '推送规则名称',
          slot: 'ruleName',
          minWidth: 180
        },
        {
          title: '推送活动',
          slot: 'activityName',
          minWidth: 140
        },
        {
          title: '人群包',
          slot: 'crowdNames',
          tooltip: true,
          tooltipMaxWidth: 300,
          minWidth: 140
        },
        {
          title: '活动入口',
          slot: 'entryNames',
          minWidth: 180
        },
        {
          title: '每日触发次数',
          slot: 'dailyTriggerLimit',
          minWidth: 100,
          align: 'center'
        },
        {
          title: '优先级',
          key: 'priority',
          minWidth: 80,
          align: 'center'
        },
        {
          title: '状态',
          slot: 'status',
          width: 80,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 160,
          align: 'center'
        }
      ]
    }
  },
  computed: {
    activityEntryTypeOptions() {
      return ACTIVITY_ENTRY_TYPE_OPTIONS
    },
    currentCrowdOptions() {
      return this.searchForm.activityConfigId
        ? this.activityCrowdOptions
        : this.globalCrowdOptions
    }
  },
  methods: {
    normalizeActivityOption(item = {}) {
      return {
        id: item.id,
        activityName: item.activityName
      }
    },
    async loadActivityOptions(query = '') {
      this.activityLoading = true
      try {
        const { data } = await getActivityConfigOptions({
          current: 1,
          size: 100,
          activityName: query || undefined
        })
        this.activityOptions = (data.records || data.list || data || []).map(
          (item) => this.normalizeActivityOption(item)
        )
      } catch (error) {
        this.$Message.error('获取活动列表失败')
      } finally {
        this.activityLoading = false
      }
    },
    searchActivities: debounce(function (query) {
      this.loadActivityOptions(query)
    }, 300),
    ensureActivityOption(id, activityName) {
      if (!id || !activityName) return
      const exists = this.activityOptions.some(
        (item) => Number(item.id) === Number(id)
      )
      if (!exists) {
        this.activityOptions.unshift({
          id: Number(id),
          activityName
        })
      }
    },
    async fetchGlobalCrowdPackages() {
      this.crowdLoading = true
      try {
        const { data } = await getCrowdList({ current: -1, size: -1 })
        this.globalCrowdOptions = (data.records || []).map((item) => ({
          id: item.id,
          name: item.name
        }))
      } catch (error) {
        this.$Message.error('获取人群包列表失败')
      } finally {
        this.crowdLoading = false
      }
    },
    async loadActivityCrowdOptions(activityConfigId) {
      if (!activityConfigId) {
        this.activityCrowdOptions = []
        return
      }
      this.crowdLoading = true
      try {
        const { data } = await getActivityPushCrowds(activityConfigId)
        this.activityCrowdOptions = (data.crowdList || []).map((item) => ({
          id: item.crowdId,
          name: item.crowdName
        }))
      } catch (error) {
        this.activityCrowdOptions = []
        this.$Message.error('获取活动可选人群包失败')
      } finally {
        this.crowdLoading = false
      }
    },
    async handleActivityFilterChange(activityConfigId) {
      this.searchForm.crowdId = ''
      await this.loadActivityCrowdOptions(activityConfigId)
    },
    buildQueryParams() {
      return {
        activityConfigId:
          this.searchForm.activityConfigId !== ''
            ? this.searchForm.activityConfigId
            : undefined,
        entryType:
          this.searchForm.entryType !== ''
            ? this.searchForm.entryType
            : undefined,
        status:
          this.searchForm.status !== '' ? this.searchForm.status : undefined,
        ruleName: this.searchForm.ruleName || undefined
      }
    },
    getSelectedCrowdName() {
      const selected = this.currentCrowdOptions.find(
        (item) => Number(item.id) === Number(this.searchForm.crowdId)
      )
      return selected ? selected.name : ''
    },
    async fetchAllRecords(params) {
      const records = []
      let current = 1
      let total = 0
      const size = 1000

      do {
        const { data } = await getActivityPushRuleList({
          ...params,
          current,
          size
        })
        const pageRecords = data.records || []
        records.push(...pageRecords)
        total = Number(data.total || pageRecords.length)
        current += 1
        if (!pageRecords.length) {
          break
        }
      } while (records.length < total)

      return records
    },
    async getData(current) {
      if (current) this.page.current = current
      this.tableLoading = true
      try {
        const baseParams = this.buildQueryParams()
        if (this.searchForm.crowdId) {
          const crowdName = this.getSelectedCrowdName()
          const allRecords = await this.fetchAllRecords(baseParams)
          const filteredRecords = crowdName
            ? allRecords.filter((item) =>
                String(item.crowdNames || '').includes(crowdName)
              )
            : allRecords
          this.page.total = filteredRecords.length
          const start = (this.page.current - 1) * this.page.size
          this.tableData = filteredRecords.slice(start, start + this.page.size)
        } else {
          const { data } = await getActivityPushRuleList({
            ...baseParams,
            current: this.page.current,
            size: this.page.size
          })
          this.tableData = data.records || []
          this.page.total = data.total || 0
        }
      } catch (error) {
        this.$Message.error('获取活动推送列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    handleReset() {
      this.searchForm = {
        activityConfigId: '',
        crowdId: '',
        entryType: '',
        status: '',
        ruleName: ''
      }
      this.activityCrowdOptions = []
      this.getData(1)
    },
    async handleOpenEditModal(row) {
      if (row) {
        try {
          this.tableLoading = true
          const { data } = await getActivityPushRuleDetail(row.id)
          this.editForm = data
          this.editReadonly = false
          this.editVisible = true
        } catch (error) {
          this.$Message.error('获取规则详情失败')
        } finally {
          this.tableLoading = false
        }
      } else {
        this.editForm = {}
        this.editReadonly = false
        this.editVisible = true
      }
    },
    async handleView(row) {
      try {
        this.tableLoading = true
        const { data } = await getActivityPushRuleDetail(row.id)
        this.editForm = data
        this.editReadonly = true
        this.editVisible = true
      } catch (error) {
        this.$Message.error('获取规则详情失败')
      } finally {
        this.tableLoading = false
      }
    },
    async handleStatusChange(row, val) {
      if (this.tableLoading || this.statusChangingId) return

      const previousStatus = Number(row.status)
      const nextStatus = Number(val)
      if (previousStatus === nextStatus) return

      this.statusChangingId = row.id
      // 先让行数据与开关保持一致，请求失败时回滚，
      // 避免出现“开关已打开但后台没有生效”的假状态
      this.$set(row, 'status', nextStatus)

      try {
        await changeActivityPushRuleStatus(row.id)
        this.$Message.success('状态切换成功')
        await this.getData(this.page.current)
      } catch (error) {
        this.$set(row, 'status', previousStatus)
        this.$Message.error('状态切换失败')
      } finally {
        this.statusChangingId = ''
      }
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '提示',
        content: `是否确定删除该活动推送规则: "${row.ruleName}"?`,
        onOk: async () => {
          try {
            await removeActivityPushRule(row.id)
            this.$Message.success('删除成功')
            this.getData(1)
          } catch (error) {
            this.$Message.error('删除失败')
          }
        }
      })
    }
  },
  mounted() {
    this.loadActivityOptions('')
    this.fetchGlobalCrowdPackages()
    this.getData()
  }
}
</script>

<style scoped lang="less">
.h5-activity-push-list {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header-container {
  margin-bottom: 20px;
  flex-shrink: 0;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  align-content: flex-start;
}

.filter-item {
  flex: 0 1 180px;
  min-width: 180px;
  max-width: 220px;
}

.btn-add {
  margin-left: auto;
}

.table-container {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;

  a {
    color: #2d8cf0;

    &:hover {
      color: #57a3f3;
    }
  }
}

.id-text {
  color: #999;
  font-size: 12px;
}

@media (max-width: 1320px) {
  .btn-add {
    margin-left: 0;
  }
}

@media (max-width: 960px) {
  .filter-item {
    flex: 1 1 100%;
    min-width: 0;
    max-width: none;
  }
}
</style>
